<template>
  <div class="event-field fn-clear">
    <Radio class="fn-left" :label="label"></Radio>
    <div class="event-content fn-left">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    label: {
      type: Number,
      default: null,
    },
  },
});
</script>

<style scoped>
.event-field {
  margin-bottom: 5px;
}
.event-content {
  background: #fff;
  margin-left: -15px;
  padding-left: 5px;
  position: relative;
  z-index: 2;
}
</style>
